import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Newspaper, ExternalLink, Loader2 } from "lucide-react";

function timeAgo(pub) {
  if (!pub) return "";
  const t = new Date(pub).getTime();
  if (isNaN(t)) return "";
  const mins = Math.floor((Date.now() - t) / 60000);
  if (mins < 60) return `${Math.max(1, mins)}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export default function DynastyWire() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get("/news/wire?limit=14")
      .then((r) => { if (alive) setItems(r.data.items || []); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  if (!loading && items.length === 0) return null;

  return (
    <section data-testid="dynasty-wire">
      <div className="flex items-center gap-2 mb-3">
        <Newspaper className="w-4 h-4 text-[var(--accent)]" />
        <div className="text-xs tracking-widest text-[var(--text-3)]">DYNASTY WIRE</div>
        <span className="ml-1 inline-flex h-1.5 w-1.5 rounded-full bg-[var(--accent)] animate-pulse" />
      </div>

      {loading ? (
        <div className="card-bordered p-8 flex items-center justify-center text-[var(--text-3)]">
          <Loader2 className="w-4 h-4 animate-spin mr-2" /> Loading the wire…
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {items.map((n, i) => (
            <a key={n.link || i} href={n.link} target="_blank" rel="noopener noreferrer"
              className="card-bordered p-4 group hover:border-[var(--accent)]/40 transition-colors flex flex-col"
              data-testid={`wire-item-${i}`}>
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-[10px] font-mono tracking-widest text-[var(--accent)] uppercase truncate">{n.source}</span>
                <span className="text-[10px] text-[var(--text-3)] shrink-0 ml-2">{timeAgo(n.published)}</span>
              </div>
              <div className="text-sm font-medium leading-snug group-hover:text-[var(--accent)] transition-colors line-clamp-2">
                {n.title}
              </div>
              {n.description && (
                <p className="text-xs text-[var(--text-3)] mt-1.5 line-clamp-2">{n.description}</p>
              )}
              <div className="mt-auto pt-2 text-[10px] text-[var(--text-3)] inline-flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                Read <ExternalLink className="w-3 h-3" />
              </div>
            </a>
          ))}
        </div>
      )}
    </section>
  );
}
